function addLeadingZero(num) {
  return num < 10 ? '0' + num : num;
}

var countDownDate = new Date('Jan 01, 2026 07:00:00').getTime();
var x = setInterval(function () {
  var now = new Date().getTime();
  var distance = countDownDate - now;
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  document.querySelectorAll('#christmas-banner-counter, #new-christmas-banner-counter').forEach(function (element) {
    element.innerHTML =
      '<span>' +
      addLeadingZero(days) +
      '</span><span>  :  </span><span>' +
      addLeadingZero(hours) +
      '</span><span>  :  </span><span>' +
      addLeadingZero(minutes) +
      '</span><span>  :  </span><span>' +
      addLeadingZero(seconds) +
      '</span>';
  });
  if (distance < 0) {
    clearInterval(x);
    document.querySelectorAll('#christmas-banner-counter, #new-christmas-banner-counter').forEach(function (element) {
      element.innerHTML = 'EXPIRED';
    });
  }
}, 1000);

function initLottie() {
  const player = document.getElementById('christmas-lottie-player');
  if (!player) return;

  player.play();
  setInterval(() => {
    player.stop();
    player.play();
  }, 5000);
}

function dropdownToggle() {
  const dropdownToggle = document.querySelector('.christmas-banner-dropdown-toggle');
  const dropdown = document.querySelector('.christmas-banner-dropdown');

  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

  dropdownToggle.addEventListener('click', () => {
    dropdown.classList.toggle('active');
    dropdownToggle.classList.toggle('active');
  });

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

    // Егер пользователь скролит вниз
    if (currentScroll > lastScrollTop) {
      dropdown.classList.remove('active');
      dropdownToggle.classList.remove('active');
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initLottie();
  dropdownToggle();
});
